// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"I","newsItemBox":"I","img-box":"J","imgBox":"J","img-mask-box":"K","imgMaskBox":"K"};